import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loader from '../common/loader';
import { Link, useNavigate } from 'react-router-dom';
import '../../common/css/noticeList.css';

function NoticeDetail() {
    const [FareStatue, setFareStatue] = useState('');
    const [Idx, setIdx] = useState('');
    const [DetailData, setDetailData] = useState(null);
    const [isFetched, setIsFetched] = useState(false);
    const [Path, setPath] = useState('');
    const [fileHref, setFileHref] = useState('');
    const navigate = useNavigate();

    const historyBack = () => {
        const path = window.location.pathname.split('/');
        const basePath = path.slice(0, -1).join('/');

        navigate(basePath);
    };

    const checkNoticeStatus = () => {
        const path = window.location.pathname.split('/')[2];
        setPath(path);
        if (path === 'all') {
            setFareStatue('전체 요금 보기');
        } else if (path === 'regular') {
            setFareStatue('정규 포괄 요금');
        } else if (path === 'discount') {
            setFareStatue('정규 특가 요금');
        } else if (path === 'special') {
            setFareStatue('특정일 특가');
        }
    };

    useEffect(() => {
        if (Path !== '') {
            const getData = async () => {
                try {
                    const hostname = window.location.hostname;
                    let isLocal = null;
                    if (hostname === 'localhost' || hostname === 'twpal.philippineair.co.kr') {
                        isLocal = false;
                    } else {
                        isLocal = true;
                    }

                    const response = await axios.get(
                        `${
                            isLocal
                                ? process.env.REACT_APP_PRODUCTION_API_URL
                                : process.env.REACT_APP_LOCAL_API_URL
                        }/wpal/board/price/${Path}/${Idx}`,
                    );
                    setDetailData(response.data);
                    console.log(response.data);
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setIsFetched(true);
                }
            };

            if (!isFetched) {
                getData();
            }
        }
    }, [Path, Idx]);

    useEffect(() => {
        if (DetailData) {
            const oldFilePath = `https://hr.raksogroup.com/board/post/file_download_ajax.asp?uploadFileIdx=${DetailData.files[0]?.fileIdx}`;
            setFileHref(oldFilePath);
        }
    }, [DetailData]);

    useEffect(() => {
        checkNoticeStatus();
        setIdx(window.location.search.split('=')[1]);
    }, []);

    return (
        <div id='contents' className='notice-contents'>
            {isFetched ? (
                <>
                    <div class='subp_h_wrap'>
                        <div class='subp_h_list'>
                            <div class='subp_h_home'></div>
                            <div>운임안내</div>
                            <div>{FareStatue}</div>
                        </div>
                    </div>
                    <div class='page_hgroup'>
                        <h2 class='title'>{FareStatue}</h2>
                        <div className='fare-sub-title'>
                            본 메뉴는 한국 출발 판매가의 "LOW~"로 시작되는 특가 운임표는 미포함 되며
                            특가 운임의 경우 GDS 시스템 통해 확인 해주시기 바랍니다.
                        </div>
                    </div>
                    <div class='event_view'>
                        <div class='view'>
                            <div
                                class='title_wrap'
                                style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                                <p class='detail-title'>{DetailData.board.postTitle}</p>
                                <p class='period'>{DetailData.board.createDate.split(' ')[0]}</p>
                            </div>
                            <div
                                className='con_wrap'
                                dangerouslySetInnerHTML={{
                                    __html: DetailData.board.content
                                        .replaceAll(/&quot;/g, '"')
                                        .replaceAll(/&amp;/g, '&')
                                        .replaceAll(/&lt;/g, '<')
                                        .replaceAll(/&gt;/g, '>')
                                        .replace(/font-family:\s*["']?[^;"']+["']?;?/gi, ''),
                                }}
                            ></div>
                            {DetailData?.files[0] && (
                                <div class='download_wrap'>
                                    <a href={fileHref}>
                                        <span>{DetailData?.files[0].fileName}</span>
                                    </a>
                                </div>
                            )}
                            <div class='other_writing_wrap'>
                                {!DetailData.prevBoard ? (
                                    ''
                                ) : (
                                    <Link
                                        className='prev'
                                        to={`/price/${Path}/detail?idx=${DetailData.prevBoard.postIdx}`}
                                        onClick={() =>
                                            (window.location.href = `/fare/${Path}/detail?idx=${DetailData.prevBoard.postIdx}`)
                                        }
                                    >
                                        <span>이전글</span>
                                        <span className='wpal-limited-text'>
                                            {DetailData.prevBoard.postTitle}
                                        </span>
                                    </Link>
                                )}
                                {!DetailData.nextBoard ? (
                                    ''
                                ) : (
                                    <Link
                                        className='next'
                                        to={`/price/${Path}/detail?idx=${DetailData.nextBoard.postIdx}`}
                                        onClick={() =>
                                            (window.location.href = `/fare/${Path}/detail?idx=${DetailData.nextBoard.postIdx}`)
                                        }
                                    >
                                        <span className='wpal-limited-text'>
                                            {DetailData.nextBoard.postTitle}
                                        </span>
                                        <span>다음글</span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                    <div class='btn_wrap mt30'>
                        <a class='btn36 gray list' style={{ width: '130px' }} onClick={historyBack}>
                            목록보기
                        </a>
                    </div>
                </>
            ) : (
                <Loader></Loader>
            )}
        </div>
    );
}

export default NoticeDetail;
